/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number4Light = () => (
	<>
		<circle cx="16" cy="16" r="16" fill="white" />
		<path
			d="M13.195 24.97C12.985 24.97 12.82 24.805 12.82 24.595V23.755C12.82 23.56 12.97 23.395 13.165 23.38C14.7625 23.245 14.7625 23.095 14.7625 22.0975V20.5075H7.75C7.54 20.5075 7.375 20.3425 7.375 20.1325V19.39C7.375 19.3075 7.3975 19.2325 7.4425 19.1725L15.8425 7.5325C15.91 7.435 16.0225 7.375 16.15 7.375H19.1275C19.3375 7.375 19.5025 7.54 19.5025 7.75V18.6025H21.9325C22.1425 18.6025 22.3075 18.7675 22.3075 18.9775V20.1325C22.3075 20.3425 22.1425 20.5075 21.9325 20.5075H19.5025V22.0975C19.5025 23.065 19.5025 23.245 21.1 23.38C21.295 23.395 21.445 23.56 21.445 23.755V24.595C21.445 24.805 21.28 24.97 21.07 24.97H13.195ZM14.7625 18.6025V12.2725L10.18 18.61H14.7625V18.6025Z"
			fill="#B9DEFA"
		/>
	</>
);

export default Number4Light;
